import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button, Container } from '@mui/material';

const NavButton = ({ to, label }) => {
  const { pathname } = useLocation();
  const active = pathname === to || pathname === to.replace(/\/$/, '');
  return (
    <Button component={Link} to={to} color={active ? 'inherit' : 'info'} variant={active ? 'contained' : 'text'} size="small" sx={{ mr: 1 }}>
      {label}
    </Button>
  );
};

export default function LayoutPms() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f7f7f7' }}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>HadriPMS</Typography>
          <NavButton to="/pms" label="Dashboard" />
          <NavButton to="/pms/reservas" label="Reservas" />
          <NavButton to="/pms/hospedes" label="Hóspedes" />
          <NavButton to="/pms/quartos" label="Quartos" />
          <NavButton to="/pms/financeiro" label="Financeiro" />
          <NavButton to="/pms/configuracoes" label="Configurações" />
          <NavButton to="/pms/configurador-site" label="Site" />
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
